<template>
  <div class="bg_box">
    <div class="content">
      <p class="header">数据资产平台</p>
      <div class="text">当合同签署完成后，这份具有法律效力的文件不再仅仅是传统意义上的合约记录，在这里，合同成为了宝贵的数据资产，开启了价值释放的全新旅程。</div>
      <p class="title">数据智仓</p>
      <div class="list_ul">
        支持多种数据源类型，自动构建高性能数据仓库，支持大规模数据存储和快速查询，多层级数据资产分类管理，可自由创建多级分类。
      </div>
      <p class="title">数据治理</p>
      <div class="list_ul">
        数据质量智能评估，对数据清洗转换，利用算法模型、逻辑推理、自然语言处理等对数据进行标准化处理，借助深度学习算法智能分类数据。
      </div>
      <p class="title">数据分析</p>
      <div class="list_ul">
        提供丰富的数据分析算法和模型，基于海量数据训练基础，发现数据中的潜在模式和趋势，为决策提供支持。
      </div>
      <p class="title">资产入表</p>
      <div class="list_ul">
        与专业数据资产盘点团队合作，对企业数据资产进行全方位的梳理评估，严格遵循《企业会计准则》中关于无形资产确认和计量的相关规定，制定详细的数据资产入表流程。
      </div>
      <p class="title">资产确权</p>
      <div class="list_ul">
        利用区块链技术的不可篡改性和分布式特性，为数据资产提供唯一且可追溯的标识，确保数据资产的权属清晰、交易透明。
      </div>
      <div class="positon_box">
        <!-- 账号身份列表 -->
        <div v-if="!isInDingTalk && showChangeAccount" class="change-account-sty">
          <change-account-com
            @showExpandIcon="()=>{}"
            @justCall="pointCall"
            :showImg="false"
            :justSwitching="true"
            :hideSelf="true"
            :users="consoleUsers"
            :lineHeight="59"
          />
        </div>
      </div>
      <div class="footer_box">
        <div class="submit_btn" @click="gotoJunziqianPrmLogin" tabindex="0" :hidefocus="true"
             @blur="closeChangeAccountFn">立即使用
        </div>
        <el-popover
          placement="top"
          width="100"
          trigger="click">
          <div class="browser_list">
            <div class="list_1" @click="browserDowload('https://www.google.cn/chrome/')">谷歌浏览器</div>
            <div class="list_1" @click="browserDowload('https://www.firefox.com.cn/')">火狐浏览器</div>
            <div class="list_1" @click="browserDowload('https://browser.360.cn/ee/')">360极速浏览器</div>
          </div>
          <span class="browser_text" slot="reference">推荐下载新版浏览器</span>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
  import {isInDingTalk} from "../../assets/js/utils/ding-env";
  import {ApiMethods} from "../../assets/js/http-serve/http-methods";
  import {setCurrentUser} from "../../assets/js/http-serve/corp/common";
  import ChangeAccountCom from "@/components/change-account";

  export default {
    name: "index",
    components: {
      ChangeAccountCom,
    },
    data() {
      return {
        showChangeAccount: false, // 是否显示切换账号弹窗
        isInDingTalk,
        browserVersionSupport: false,
      }
    },
    layout: 'initPage',
    computed: {
      // 获取拥有控制台权限的用户
      consoleUsers() {
        try {
          let users = this.$store.getters.allAuthUser.bindCorpUsers;
          let consoleUsers = [];
          // console.log(this.$store.getters.allAuthUser);
          if (this.$store.getters.allAuthUser.corpCreateFlag === 1) {
            // 超级管理员
            consoleUsers.push(this.$store.getters.allAuthUser.manCorpUser);
          }
          users.forEach(user => {
            if (user.perms && user.perms.length > 0) {
              consoleUsers.push(user);
            }
          });
          return consoleUsers;
        } catch (e) {
          return [];
        }
      },
    },
    mounted() {
      this.getBrowserVersion();
    },
    methods: {
      getBrowserVersion() {
        // 使用正则表达式匹配用户代理字符串中的版本信息
        const userAgent = navigator.userAgent;
        let match;
        // 主要浏览器的版本匹配
        if (userAgent.indexOf("Firefox") !== -1) {
          match = userAgent.match(/Firefox\/([\d.]+)/);
          if (match[1].split('.')[0] > 44) {
            this.browserVersionSupport = true;
          }
          console.log(1)
        } else if (userAgent.indexOf("Chrome") !== -1) {
          match = userAgent.match(/Chrome\/([\d.]+)/);
          if (match[1].split('.')[0] > 31) {
            this.browserVersionSupport = true;
          }
          console.log(2)
        } else if (userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident") !== -1) {
          match = userAgent.match(/MSIE (\d+[\.\d]+);/);
        } else if (userAgent.indexOf("Safari") !== -1) {
          match = userAgent.match(/Version\/([\d.]+).+Safari/);
          if (match[1].split('.')[0] > 9) {
            this.browserVersionSupport = true;
          }
        } else if (userAgent.indexOf("Edg") !== -1) {
          match = userAgent.match(/Edg\/([\d.]+)/);
          if (match[1].split('.')[0] > 14) {
            this.browserVersionSupport = true;
          }
          console.log(3)
        } else {
          console.log(4)
        }
        console.log(match[1], '-==-')
        return match ? match[1] : "unknown";
      },
      /** 资产管理系统选择成员回调 */
      pointCall(user) {
        // 切换后，调用给成员充值METHODS
        setCurrentUser(user).finally(() => {
          this.gotoAssetsFn();
        })
      },
      gotoJunziqianPrmLogin() {
        if (this.browserVersionSupport) {
          if (this.$store.getters.authUser.userType === 0) {
            this.showChangeAccount = true;
          } else {
            this.gotoAssetsFn();
          }
        } else {
          this.$confirm('当前浏览器可能不支持该系统, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (this.$store.getters.authUser.userType === 0) {
              this.showChangeAccount = true;
            } else {
              this.gotoAssetsFn();
            }
          }).catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除'
            // });
          });
        }
      },
      //关闭弹窗
      closeChangeAccountFn() {
        setTimeout(() => {
          this.showChangeAccount = false;
        }, 200)
      },
      gotoAssetsFn() {
        ApiMethods.IdenAuthController.getKnowledgeLink().then(res => {
          if (res.data) {
            window.open(res.data, '_self');
          } else {
            if (res.code === '10402') {
              this.$message({
                message: '登录过期，请重新登录后跳转',
                type: 'warning'
              });
            }
          }
        })
      },
      browserDowload(url) {
        window.open(url);
      }
    }
  }
</script>
<style lang="less" scoped>
  .browser_list {
    padding: 10px 4px;
    text-align: center;
    cursor: pointer;
  }

  .list_1:hover {
    background-color: #e0e0e0;
  }

  .list_1 {
    text-align: center;
    color: #386df6;
    padding: 5px;
  }

  .bg_box {
    background-image: url("../../static/images/initPage.jpg");
    background-size: 100% 100%;
    height: 100vh;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 10%;

    .content {
      background-color: rgba(255, 255, 255, 0.6);
      border-radius: 10px;
      width: 600px;
      padding: 10px 20px;
      position: relative;

      .header {
        font-weight: bold;
        font-size: 16px;
      }

      .text {
        font-size: 12px;
      }

      .title {
        background-color: #169bd5;
        border-radius: 4px;
        display: inline-block;
        padding: 2px 10px;
        color: #ffffff;
        margin: 10px 4px 2px 4px;
      }

      .list_ul {
        font-size: 14px;
      }

      .positon_box {
        width: 150px;
        margin: 0 auto;
        position: relative;

        .change-account-sty {
          width: 200px;
          background-color: #fff;
          border-radius: 6px;
          box-shadow: 0 0 15px 1px rgba(236, 28, 28, 0.3);
          z-index: 1;
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }

      .footer_box {
        text-align: center;
        position: relative;

        .browser_text {
          cursor: pointer;
          color: #ec1c1c;
          position: absolute;
          bottom: 8px;
          right: 10px;
        }

        .submit_btn:hover {
          opacity: 0.9;
        }

        .submit_btn {
          display: inline-block;
          background-color: #386df6;
          width: 150px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-radius: 6px;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// pages/introducePage/index.vue